import { Key, RefObject, useEffect, useState } from 'react';

const SCROLLABLE_NODE_CLS_PREFIX = 'scrollable-node-key-';

const getClsByNodeId = (nodeId: Key) => {
    return `${SCROLLABLE_NODE_CLS_PREFIX}${nodeId}`;
};

const useTreeNodeScrollTo = (
    {
        containerRef
    }: {
        /** 滚动容器 */
        containerRef: RefObject<any>;
    },
    deps: any[]
) => {
    const [nodeIdToScroll, setNodeIdToScroll] = useState<Key>();

    useEffect(() => {
        if (nodeIdToScroll) {
            const timer = setTimeout(() => {
                const escapedNodeId = CSS.escape(String(nodeIdToScroll));
                const $node = containerRef.current?.querySelector(
                    `.${SCROLLABLE_NODE_CLS_PREFIX}${escapedNodeId}`
                );
                if ($node) {
                    $node.scrollIntoView({ block: 'center', behavior: 'smooth' });
                    setNodeIdToScroll(undefined);
                }
            }, 200);
            return () => clearTimeout(timer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nodeIdToScroll, ...deps]);

    return {
        getClsByNodeId,
        setNodeIdToScroll
    };
};

export default useTreeNodeScrollTo;
